"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "paitone": {
    "1e931ce5": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "skipSearch": false
    }],
    "bettola": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1a8202ef": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "skipSearch": false
    }],
    "colombaro": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6380ce0f": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "skipSearch": false
    }],
    "risoline": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a3558735": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "skipSearch": false
    }],
    "soina": [{
      "hkey": "c4727162",
      "slug": "paitone",
      "name": "Paitone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;